import { BuilderField } from '../fb/models/builder.model';

const alreadyLogged = {};

export class BuilderHelper {

  static EFormElement = Object.freeze({
    PrimaryKey: 0,
    Lookup: 1,
    Picklist: 2,
    Checkboxlist: 3,
    Text: 4,
    Html: 5,
    Integer: 6,
    Float: 7,
    Money: 8,
    Boolean: 9,
    DateTime: 10,
    EditableGrid: 11,
    Image: 12,
  });

  static inputFields = [
    'TextField',
    'TextBox',
    'TextArea',
    'EmailField',
    'NumberField',
    'MoneyField',
    'PositiveNumber',
    'CheckBox',
    'Toggle',
    'RadioButton',
    'UploadFile',
    'ListField',
    'Picklist',
    'Lookup',
    'RadioButtonList',
    'DropDownList',
    'Date',
    'Time',
    'DateTime',
  ];

  static formFields = ['Label', 'Button', 'EditableGrid', 'MenuGrid', 'ProgressBar'];

  static designFields = [
    'HiddenField',
    'TableLayout',
    'BootstrapRow',
    'SectionLayout',
    'FlexRow',
    'HtmlContent',
    'FormTab',
    'Form',
    'CustomControl',
  ];

  /**
   * Dublicate identifiers of same control but with different name(ex: Text > TextField, Float > NumberField).
   */
  static FieldsAssigns = {
    Text: 'TextField',
    Integer: 'NumberField',
    Float: 'NumberField',
    Money: 'MoneyField',
    Boolean: 'CheckBox',
  };
  static isHidden(control: BuilderField, forced: boolean = false, shouldShow?: boolean, builderOn?: boolean): boolean {
    if (builderOn && !forced) {
      return false;
    }
    return !shouldShow || control.isHidden || BuilderHelper.ControlType(control.fieldType) === 'hiddenfield';
  }

  static ControlType(type: string | number) {
    const enums = BuilderHelper.EFormElement;
    let fieldType = Object.keys(enums).find(key => key === type || enums[key] === type);
    type = BuilderHelper.FieldsAssigns[type] || type;
    if (BuilderHelper.FieldsAssigns[fieldType]) {
      fieldType = BuilderHelper.FieldsAssigns[fieldType];
    }
    if (!fieldType && type) {
      // Log once
      if (alreadyLogged[type]) {
        return;
      }
      alreadyLogged[type] = true;
      console.warn('Could not find type by ', type);
    }
    return fieldType;
  }

  static ControlGroupType(type: string | number) {
    if (typeof type === 'string') {
      return BuilderHelper.controlGroupType(BuilderHelper.EFormElement[type]);
    }
    return BuilderHelper.controlGroupType(type);
  }

  static controlGroupType(num: number) {
    return (
      (BuilderHelper.isInputField(num) && 'input') ||
      (BuilderHelper.isFormField(num) && 'form') ||
      (BuilderHelper.isDesignField(num) && 'design') ||
      'undefined'
    );
  }

  static isInputField(num: number) {
    const fieldType = BuilderHelper.ControlType(num);
    const inputFields = BuilderHelper.inputFields;
    return inputFields.indexOf(fieldType) !== -1;
  }

  static isFormField(num: number) {
    const fieldType = BuilderHelper.ControlType(num);
    const formFields = BuilderHelper.formFields;
    return formFields.indexOf(fieldType) !== -1;
  }

  static isDesignField(num: number) {
    const fieldType = BuilderHelper.ControlType(num);
    const designFields = BuilderHelper.designFields;
    return designFields.indexOf(fieldType) !== -1;
  }
}
